<template>
    <div :class="margin ? 'margin' : ''">
        <h3>{{title}}</h3>
    </div>
</template>

<script>
export default {
    props:['title', 'margin'],
    data() {
        return {
            firma:  document.querySelector('meta[name="firma"]').getAttribute('content'),
        }
    },
}
</script>

<style lang="scss" scoped>
div{
    &.margin{
        margin: 30px 35px 15px;
        @media only screen and (max-width: 1300px) {
         margin: 30px 10px 15px;
        }
        @media (max-width: 600px) {
            margin: 16px 10px 15px;
        }
    }
    h3{
        font-family: Montserrat;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 110%;
        color: #212541;  
        margin: 0 0 4px 0;
    }
    p{
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 0.1em;
        text-transform: uppercase;
        color: #F3385A;
        margin: 0;
    }
}
</style>